/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// @flow

import React, { Component } from 'react';
import * as DOMPurify from 'dompurify';

import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import EmptyState from 'components/competitionsInternationales/CompetitionsinternationalesSingleMatchEmptyState';
import PrevAndNextMatchesLinks from 'components/competitionsInternationales/PrevAndNextMatchesLinks';
import SingleMatchCard from 'components/competitionsInternationales/SingleMatchCard';
import { STATUS_SUCCESS } from 'constants/statusConstants';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { RencontreType } from 'types/Rencontre';
import CompetitionsInternationalesSingleMatchStats from 'components/competitionsInternationales/CompetitionsinternationalesSingleMatchStats';
import CompetitionsInternationalesSingleMatchComposition from './CompetitionsinternationalesSingleMatchComposition';
// import './CompetitionsInternationalesSingleMatch.css';
import type { Status } from 'types/Status';
import { formatFullDateString } from 'utils/dateUtils';

export type StateProps = {
  competition: {
    id: string,
    name: string,
    slug: string
  },
  rencontre: RencontreType,
  status: Status
};

type Props = StateProps;

type State = {
  activeComponent: string
};

class CompetitionsInternationalesSingleMatchToCome extends Component<Props, State> {
  state: State = {
    activeComponent: ''
  };

  render() {
    const {
      rencontre,
      rencontre: { content_next_match_block, news_prematch }
    } = this.props;
    const { activeComponent } = this.state;

    const firstTeam = !!rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;
    const secondTeam = !rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;
    const pageTitle = `Match ${firstTeam} vs ${secondTeam} <br /> ${formatFullDateString(
      new Date(rencontre.meta.date_rencontre)
    )}`;

    return (
      <>
        <h2 className="page-title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pageTitle) }} />

        {!!content_next_match_block && !!content_next_match_block.data && !!content_next_match_block.data.length ? (
          content_next_match_block.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)
        ) : (
          <SingleMatchCard rencontre={rencontre.meta} equipeNom={'France'} />
        )}

        <nav className="single-match__nav">
          <ul>
            <li
              className={activeComponent === '' ? 'active' : ''}
              onClick={() => this.setState({ activeComponent: '' })}
            >
              <span>Avant-match</span>
            </li>

            <li
              className={activeComponent === 'composition' ? 'active' : ''}
              onClick={() => this.setState({ activeComponent: 'composition' })}
            >
              <span>Composition</span>
            </li>

            <li
              className={activeComponent === 'statistiques' ? 'active' : ''}
              onClick={() => this.setState({ activeComponent: 'statistiques' })}
            >
              <span>Statistiques</span>
            </li>
          </ul>
        </nav>

        {activeComponent === '' && (
          <article className="container article">
            {!!news_prematch &&
            !!news_prematch.content &&
            !!news_prematch.content.data &&
            !!news_prematch.content.data.length ? (
              news_prematch.content.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)
            ) : (
              <EmptyState
                titleFirstPart="Avant"
                titleSecondPart="-match"
                description="Les actualités d'avant-match seront disponibles très prochainement."
                backgroundImage="/img/empty-state-avant-match.png"
              />
            )}
          </article>
        )}

        {activeComponent === 'composition' && (
          <CompetitionsInternationalesSingleMatchComposition rencontre={rencontre} />
        )}

        {activeComponent === 'statistiques' && <CompetitionsInternationalesSingleMatchStats rencontre={rencontre} />}

        <PrevAndNextMatchesLinks prevAndNextMatchesLinks={rencontre.prev_and_next_match_links} />

        {!!rencontre &&
          !!rencontre.content_match_to_come &&
          !!rencontre.content_match_to_come.data &&
          !!rencontre.content_match_to_come.data.length &&
          rencontre.content_match_to_come.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)}
      </>
    );
  }
}

export default withHelmet(CompetitionsInternationalesSingleMatchToCome)((Helmet, pageProps: Props) => {
  const { competition, rencontre, status } = pageProps;

  if (status !== STATUS_SUCCESS || !competition || !rencontre) {
    null;
  }

  const firstTeam = !!rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;
  const secondTeam = !rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;

  const meta_title = `Résumé & Score : ${firstTeam} vs ${secondTeam} - ${formatFullDateString(
    new Date(rencontre.meta.date_rencontre)
  )} - ${competition.name}`;

  return (
    <Helmet htmlAttributes={{ lang: 'fr' }}>
      {meta_title && <title>{meta_title}</title>}
      {meta_title && <meta property={'og:title'} content={meta_title} />}
    </Helmet>
  );
});
